import { getApiBase } from "./apiBase";
import { dropSession, isAuthError } from "./session";

/**
 * Награды человека из миров платформы.
 *
 * Отдельно от birthday/my-awards: та ручка про юбилейную покупку — лицензии
 * и Flower Box, а эта про всё, что человек получил в играх. Смешивать их на
 * бэкенде было бы неверно, это разные истории с разной судьбой.
 */
export const fetchGrants = async () => {
  const base = getApiBase();
  if (!base) {
    throw new Error("не задан адрес API");
  }

  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${base}/v1/cpai/my-grants`, {
    method: "POST",
    headers,
    body: JSON.stringify({}),
  });

  // Ручка есть на платформе (CpaiController::actionMyGrants), но на стенде
  // со старым API её может не быть. Для человека это просто пустой раздел,
  // а не ошибка.
  if (res.status === 404) {
    return { grants: [], worlds: [], total: 0 };
  }

  const data = await res.json().catch(() => ({}));

  if (isAuthError(res.status, data && data.message)) {
    dropSession();
    const error = new Error("сессия истекла, войдите заново");
    error.status = res.status;
    throw error;
  }

  if (!res.ok) {
    throw new Error(data && data.message ? data.message : `код ${res.status}`);
  }

  return data;
};

/**
 * Виды наград — со слов Максима 22.08.2026.
 *
 * «Рекламных» в ответе пока нет: на платформе такой сущности не нашлось.
 * Вид оставлен в списке, но показывается только когда такие награды
 * действительно появятся — пустая вкладка хуже отсутствующей.
 */
export const GRANT_KINDS = [
  { key: "digital", title: "Цифровые" },
  { key: "collection", title: "Коллекционные" },
  { key: "farm", title: "Фарминг" },
  { key: "ticket", title: "Билеты" },
  { key: "promo", title: "Рекламные" },
];

export const kindTitle = (key) => {
  const found = GRANT_KINDS.find((k) => k.key === key);
  return found ? found.title : "Награда";
};

/** «раз в 12 часов», «раз в 3 дня» — период фарминга человеческим языком. */
export const farmPeriod = (seconds) => {
  const s = Number(seconds);
  if (!Number.isFinite(s) || s <= 0) return null;

  const hours = Math.round(s / 3600);
  if (hours < 24) {
    return `раз в ${hours} ${hours === 1 ? "час" : hours < 5 ? "часа" : "часов"}`;
  }

  const days = Math.round(hours / 24);
  return `раз в ${days} ${days === 1 ? "день" : days < 5 ? "дня" : "дней"}`;
};
